import React from "react";

import QALibraryFilter from "./QALibraryFilter";

export function QAName({ value, dependentValues }){
	return <QALibraryFilter libraryId={dependentValues.id}><span title={value}>{value}</span></QALibraryFilter>;
}

QAName.displayName = "QAName";


const QAPanelName = {
	key: "name",
	cellClass:"link-cell cypress-qa-library-name",
	name: "Creative Library",
	resizable:true,
	sortable:true,
	formatter:QAName,
	getRowMetaData(data){
		return { id:data.id };
	},
};

export default QAPanelName;
